import React from 'react'

export default function HorizontalRowUI({children,heightValue}) {
  return (
    <div
      data-testid="horizontal-row-ui"
      className='dark:bg-gray-900 dark:text-white'
      style={{
        height: heightValue,
        backgroundColor: '#FFFFFF',
        border: '1px solid #E4E4E7',
        borderRadius: 0,
        padding: '10px',
        marginBottom: '8px',
        width: '100%',
        color: '#09090B'
      }}
    >{children}</div>
  )
}
